export default __webpack_public_path__ + "static/media/C_Forms.3b6e8dfe.png";